import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get saleOrder
export const getSaleOrder = createAsyncThunk("saleOrder/getSaleOrder", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getSaleOrder({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all saleOrder
export const getAllSaleOrder = createAsyncThunk("saleOrder/getAllSaleOrder", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllSaleOrder();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("saleOrder/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleOrder/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleOrder/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleOrder({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get SaleOrder AdditionalCharge List
export const getSaleOrderAdditionalChargeList = createAsyncThunk(
  "saleOrder/getSaleOrderAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleOrderAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getSaleOrderById = createAsyncThunk("saleOrder/getSaleOrderById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getSaleOrderById(id);

    if (data?.data.saleOrderDetails?.length > 0) {
      // get stock by id and branch
      const updatedDetailsPromises = data.data?.saleOrderDetails.map(async (detail) => {
        const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

        if (stockData.data?.length > 0) {
          return {
            ...detail,
            // availableStock stock from stockData
            availableStock: stockData.data[0]?.closingStock || "",
          };
        } else {
          return {
            ...detail,
            availableStock: 0,
          };
        }
      });

      const updatedDetails = await Promise.all(updatedDetailsPromises);
      return { ...data, data: { ...data.data, saleOrderDetails: updatedDetails } };
    } else {
      return data;
    }
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create saleOrder
export const createSaleOrder = createAsyncThunk(
  "saleOrder/createSaleOrder",
  async (createData, { rejectWithValue }) => {
    const {
      salesOrderMain,
      saleOrderDetails,
      salesOrderMainAdditionalChargeCost,
      salesOrderMainPartyDetails,
      salesOrderMainVehicleDetail,
      // invoiceNo,
      // refNo,
      voucherDateBs,
      voucherDate,
      narration,
      branch,
      termsOfDelivery,
      termOfPayment,
      deliveryDocNo,
      otherReferences,
      destination,
      salesOrderRequest,
      partyAccount,
      discountAmount,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        salesOrderMain,
        saleOrderDetails,
        salesOrderMainAdditionalChargeCost,
        salesOrderMainPartyDetails,
        salesOrderMainVehicleDetail,
        // invoiceNo,
        // refNo,
        voucherDateBs,
        voucherDate,

        branch,
        termsOfDelivery,
        termOfPayment,
        deliveryDocNo,
        otherReferences,
        destination,
        narration,
        salesOrderRequest,
        partyAccount,
        discountAmount,
        grandTotal,
        vatAmount,
      });

      const { data } = await API.createSaleOrder(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSaleOrder = createAsyncThunk("saleOrder/updateSaleOrder", async (params, { rejectWithValue }) => {
  const { id, submitData } = params;
  const {
    salesOrder,
    indentNo,
    isFromHo,
    requiredDateAd,
    voucherDateBs,
    voucherDate,
    branch,
    status,
    salesOrderMainPartyDetails,
    salesOrderMainVehicleDetail,
    // yo field name mileko thiyena, fix bhayo hai
    documentsAttach,
    // refVoucher,
    saleOrderDetails,
    salesOrderMainAdditionalChargeCost,
    discountAmount,
    grandTotal,
    vatAmount,
  } = submitData;
  try {
    const body = JSON.stringify({
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      branch,
      status,
      salesOrderMainPartyDetails,
      salesOrderMainVehicleDetail,
      voucherDateBs,
      voucherDate,
      // refVoucher,
      saleOrderDetails,
      salesOrderMainAdditionalChargeCost,
      discountAmount,
      grandTotal,
      vatAmount,
    });
    const { data } = await API.updateSaleOrder(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

//converting to Sale Invoice From Sales Order
export const convertToSaleInvoice = createAsyncThunk(
  "saleOrder/convertToSaleInvoice",
  async (createData, { rejectWithValue }) => {
    const {
      saleInvoiceDetails,
      voucherDateBs,
      voucherDate,
      branch,
      salesOrderMain,
      salesInvoiceMainAdditionalChargeCost,
      narration,
      discountAmount,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        saleInvoiceDetails,
        voucherDateBs,
        voucherDate,
        branch,
        salesOrderMain,
        salesInvoiceMainAdditionalChargeCost,
        narration,
        discountAmount,
        grandTotal,
        vatAmount,
      });

      const { data } = await API.convertToSaleInvoice(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// handle search
export const handleSearch = createAsyncThunk(
  "saleOrder/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
